import _ from 'lodash';
import { seeqVersion } from '@/services/systemConfiguration.utilities';
import { reload } from '@/utilities/browserLocation.utilities';
import { logInfo } from '@/utilities/logger';
import { SeeqNames } from '@seeqdev/constants';
import type { SeeqAxiosResponse } from '@/requests/axios.utilities';

/**
 * An HTTP interceptor that will inspect the 'Server' header for the Seeq version running on the server.
 * If the version doesn't match the frontend version, the frontend will perform a force reload.
 */
export function versionInterceptor<TResponse extends Pick<SeeqAxiosResponse, 'headers'>>(
  response: TResponse,
): TResponse {
  const serverHeader = response.headers?.[SeeqNames.API.Headers.Server] || undefined;
  if (serverHeader && typeof serverHeader === 'string' && _.includes(serverHeader, 'Seeq/')) {
    // Extract only the version part of the header (also removes any extra data added by proxies, CRAB-15461)
    const serverVersion = _.replace(serverHeader, /^(.*\s)*Seeq\/(.*?)(\s.*)*$/, '$2');
    if (serverVersion !== seeqVersion()) {
      // Server and client version don't match (e.g. server has been upgraded), so force a reload of the client
      logInfo(
        `Server and client version mismatch ('${serverVersion}' vs '${seeqVersion()}'), forcing reload of client`,
      );
      reload();
    }
  }

  return response;
}
